// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { FiUser } from "react-icons/fi";
// import { GoLock } from "react-icons/go";
// import {
//   TextField,
//   InputAdornment,
//   Box,
//   Button,
//   IconButton,
// } from "@mui/material";

// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import config from "../config";
// import SiteNavbar from "../components/SiteNavbar.js";
// import Layout from "../components/Layout.js";

// const baseUrl = config.baseURL;

// const Login = () => {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);

//     if (params.get("verified") === "true") {
//       toast.success("Email verified successfully. Please login.");
//     }

//     if (params.get("verified") === "false") {
//       toast.error("Verification failed or link expired.");
//     }
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await axios.post(baseUrl + `/auth/login`, {
//         email,
//         password,
//       });
//       console.log("Login response:", response);
//       if (response && response.status === 200) {
//         const token = response.data.accessToken;
//         localStorage.setItem("token", token);
//         toast.success("Login successful!");
//         window.location.replace("/dashboard/Home");
//       } else {
//         toast.error("Login failed. Please check your credentials.");
//       }
//     } catch (err) {
//       toast.error(
//         err.response?.data?.message || "An error occurred. Please try again."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         width: "100%",
//         backgroundColor: "#D1D8E0",
//         fontFamily: "Poppins",
//       }}
//     >
//       <ToastContainer />
//       <SiteNavbar />
//       <Box sx={{ maxWidth: 500, mx: "auto", padding: 3 }}>
//         <form onSubmit={handleSubmit}>
//           {/* Email field */}
//           <TextField
//             id="email"
//             name="email"
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             variant="outlined"
//             label="Email Address"
//             fullWidth
//             required
//             sx={{
//               marginBottom: "16px",
//               backgroundColor: "#D1D8E0",
//               color: "#2E4053",
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <FiUser className="text-white ml-2" />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Password field with eye toggle */}
//           <TextField
//             id="password"
//             name="password"
//             type={showPassword ? "text" : "password"}
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             variant="outlined"
//             label="Password"
//             fullWidth
//             required
//             sx={{
//               marginBottom: "16px",
//               backgroundColor: "#D1D8E0",
//               color: "#2E4053",
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <GoLock className="text-white ml-2" />
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={() => setShowPassword(!showPassword)}
//                     edge="end"
//                   >
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Submit button */}
//           <Button
//             type="submit"
//             variant="contained"
//             sx={{
//               marginBottom: "16px",
//               backgroundColor: "#2E4053",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "#f1f1f1",
//               },
//               display: "block",
//               marginLeft: "auto",
//               marginRight: "auto",
//             }}
//             disabled={loading}
//           >
//             {loading ? "Logging in..." : "Login"}
//           </Button>
//         </form>

//         {/* Forgot Password + Register */}
//         <Box
//           sx={{
//             display: "flex",
//             marginTop: "8px",
//             position: "relative",
//             bottom: "60px",
//             justifyContent: "space-between",
//           }}
//         >
//           <Button
//             variant="text"
//             sx={{
//               color: "#2E4053",
//               textTransform: "none",
//               fontSize: "12px",
//               "&:hover": {
//                 backgroundColor: "#2E4053",
//                 color: "white",
//               },
//             }}
//             onClick={() => navigate("/forgot-password")}
//           >
//             Forgot Password?
//           </Button>
//           <Button
//             variant="text"
//             sx={{
//               color: "#2E4053",
//               textTransform: "none",
//               fontSize: "12px",
//               "&:hover": {
//                 backgroundColor: "#2E4053",
//                 color: "white",
//               },
//             }}
//             onClick={() => window.location.replace("/Register")}
//           >
//             Register
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Login;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FiUser } from "react-icons/fi";
import { GoLock } from "react-icons/go";
import {
  TextField,
  InputAdornment,
  Box,
  Button,
  IconButton,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../config";
import SiteNavbar from "../components/SiteNavbar.js";
import Layout from "../components/Layout.js";

const baseUrl = config.baseURL;

// ── Brand tokens (matched to Spade ERP landing page) ─────────────────────────
const T = {
  dark: "#2E4053",
  darkDeep: "#1C2A3D",
  accent: "#2E4053",
  accentHov: "#1C2A3D",
  muted: "#34495E",
  border: "#A6AAAD",
  surface: "#F4F6F9",
  surfaceAlt: "#D1D8E0",
  chipText: "#D1D8E0",
  white: "#FFFFFF",
};

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("verified") === "true") {
      toast.success("Email verified successfully. Please login.");
    }

    if (params.get("verified") === "false") {
      toast.error("Verification failed or link expired.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(baseUrl + `/auth/login`, {
        email,
        password,
      });
      console.log("Login response:", response);
      if (response && response.status === 200) {
        const token = response.data.accessToken;
        localStorage.setItem("token", token);
        toast.success("Login successful!");
        window.location.replace("/dashboard/Home");
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Shared MUI field styling pulled from the landing page surface tokens
  const fieldSx = {
    marginBottom: "18px",
    backgroundColor: T.white,
    borderRadius: "10px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      "& fieldset": {
        borderColor: T.surfaceAlt,
      },
      "&:hover fieldset": {
        borderColor: T.border,
      },
      "&.Mui-focused fieldset": {
        borderColor: T.dark,
      },
    },
    "& .MuiInputLabel-root": {
      color: T.muted,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: T.dark,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
        fontFamily:
          "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
        background: `linear-gradient(135deg, ${T.dark} 0%, #1a2b3c 40%, #0d1f30 100%)`,
        position: "relative",
        overflow: "hidden",
        padding: "32px",
      }}
    >
      <ToastContainer />
      <SiteNavbar />

      {/* Geometric background decoration, matched to landing page hero */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -180,
            right: -180,
            width: 560,
            height: 560,
            borderRadius: "50%",
            border: "1px solid rgba(209,216,224,.08)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: -100,
            right: -100,
            width: 360,
            height: 360,
            borderRadius: "50%",
            border: "1px solid rgba(209,216,224,.12)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -200,
            left: -200,
            width: 600,
            height: 600,
            borderRadius: "50%",
            border: "1px solid rgba(209,216,224,.06)",
          }}
        />
      </Box>

      {/* Card */}
      <Box
        sx={{
          maxWidth: 440,
          width: "100%",
          mx: "auto",
          padding: "44px 40px 36px",
          borderRadius: "18px",
          background: T.white,
          boxShadow: "0 24px 60px rgba(0,0,0,.35)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Brand mark */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "center",
            marginBottom: "8px",
          }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              background: T.dark,
              borderRadius: "9px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ fontSize: 17, fontWeight: 900, color: T.white }}>
              S
            </span>
          </Box>
          <span
            style={{
              fontSize: 19,
              fontWeight: 800,
              color: T.dark,
              letterSpacing: -0.5,
            }}
          >
            Spade ERP
          </span>
        </Box>

        <h1
          style={{
            fontSize: 24,
            fontWeight: 800,
            color: T.dark,
            letterSpacing: -0.5,
            textAlign: "center",
            margin: "8px 0 4px",
          }}
        >
          Welcome back
        </h1>
        <p
          style={{
            fontSize: 13.5,
            color: T.muted,
            textAlign: "center",
            margin: "0 0 32px",
            lineHeight: 1.6,
          }}
        >
          Sign in to access your dashboard
        </p>

        <form onSubmit={handleSubmit}>
          {/* Email field */}
          <TextField
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            label="Email Address"
            fullWidth
            required
            sx={fieldSx}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FiUser style={{ color: T.muted }} />
                </InputAdornment>
              ),
            }}
          />

          {/* Password field with eye toggle */}
          <TextField
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            label="Password"
            fullWidth
            required
            sx={fieldSx}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GoLock style={{ color: T.muted }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff style={{ color: T.muted }} />
                    ) : (
                      <Visibility style={{ color: T.muted }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {/* Submit button */}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disableElevation
            sx={{
              marginTop: "6px",
              marginBottom: "8px",
              backgroundColor: T.dark,
              color: T.white,
              borderRadius: "10px",
              padding: "13px 0",
              fontSize: 15,
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 4px 16px rgba(46,64,83,.25)",
              transition: "transform .15s, background-color .15s",
              "&:hover": {
                backgroundColor: T.darkDeep,
                transform: "scale(1.01)",
              },
            }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>

        {/* Forgot Password + Register */}
        <Box
          sx={{
            display: "flex",
            marginTop: "12px",
            justifyContent: "space-between",
            borderTop: `1px solid ${T.surfaceAlt}`,
            paddingTop: "18px",
          }}
        >
          <Button
            variant="text"
            sx={{
              color: T.muted,
              textTransform: "none",
              fontSize: "13px",
              fontWeight: 500,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: T.surface,
                color: T.dark,
              },
            }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </Button>
          <Button
            variant="text"
            sx={{
              color: T.muted,
              textTransform: "none",
              fontSize: "13px",
              fontWeight: 500,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: T.surface,
                color: T.dark,
              },
            }}
            onClick={() => window.location.replace("/Register")}
          >
            Register
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
